import './MobileCenter.scss';
import { CurrentBets } from '../current-bets/CurrentBets';
import { History } from '../history/History';
import { useTranslation } from '../../platform/stores';
import { ITabItem } from '../../platform/interfaces/tab-button';
import { useState } from 'react';
import { LastResults } from '../last-results/LastResults';
import { Statistics } from '../statistics/Statistics';

export const MobileCenter = () => {
  const t = useTranslation();
  const tabs: ITabItem[] = [
    {
      name: 'LEFT_SIDEBAR_CURRENT_BETS',
      value: 1,
    },
    {
      name: 'LEFT_SIDEBAR_HISTORY',
      value: 2,
    },
    {
      name: 'RIGHT_SIDEBAR_RESULTS',
      value: 3,
    },
    {
      name: 'RIGHT_SIDEBAR_STATISTICS',
      value: 4,
    }
  ];
  const [tab, setTab] = useState(1);

  return (
    <div className="mobile-center-component">
      <div className="mobile-tab">
        {
          tabs.map((item) =>
            <div className={`mobile-tab-item ${tab === item.value ? 'selected' : ''}`}
                 key={item.value}
                 onClick={() => setTab(item.value)}>
              {t(item.name)}
            </div>
          )
        }
      </div>
      <div className="margin-top-10 tab-container">
        {tab === 1 ? <CurrentBets/> : <></>}
        {tab === 2 ? <History/> : <></>}
        {tab === 3 ? <LastResults/> : <></>}
        {tab === 4 ? <Statistics/> : <></>}
      </div>
    </div>
  );
};
